<template lang="">
  <div class="alarm-body">
    <p>
      <span>{{ $t(typeName) }}{{ $t('时间') }}：</span>
      <span>{{ alarmTime }}</span>
    </p>
    <p>
      <span>{{ $t('所属机构') }}：</span>
      <span>{{ officeName }}</span>
    </p>
    <p>
      <span>{{ $t('设备型号') }}：</span>
      <span>{{ deviceType }}</span>
    </p>
    <p>
      <span>{{ $t('设备名称') }}：</span>
      <span>{{ deviceName }}</span>
    </p>
    <p>
      <span>{{ $t('设备编号') }}：</span>
      <el-link @click.native="toMonitor">{{ sn }}</el-link>
    </p>
    <p>
      <span>{{ $t(typeName) }}{{ $t('内容') }}：</span>
      <span>{{ message }}</span>
    </p>
    <div v-if="authMenu['010214']" style="text-align: right; margin-top: 10px">
      <el-button size="mini" @click="toAlarmCenter">处置</el-button>
    </div>
  </div>
</template>
<script>
const dict = {
  ALARM: '报警',
  DETECT: '检测'
};

export default {
  name: 'alarmTip',
  props: {
    alarmTime: String,
    officeName: String,
    deviceType: String,
    deviceName: String,
    sn: String,
    message: String,
    type: String,
    callback: Function
  },
  data() {
    return {
      i18nPath: 'device.alarmTip'
    };
  },

  computed: {
    typeName() {
      return dict[this.type];
    }
  },

  methods: {
    toMonitor() {
      const { sn, deviceType } = this;

      this.$router.push({
        name: 'Realdata',
        params: { sn, deviceType }
      });

      this.callback();
    },
    toAlarmCenter() {
      this.$router.push({
        name: 'AirMonitorAlarmInfo'
      });
    }
  }
};
</script>
<style lang="scss">
.alarm-notice {
  .el-icon-warning {
    color: #fe4848;
  }

  .el-link {
    line-height: 1;
  }

  .el-notification__content {
    text-align: left;
    word-break: break-all;
  }
}
</style>
